import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    header: {
      cursor: "pointer",
      padding: "0.8rem 2.6rem",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "60px",
      "& .MuiTypography-root": {
        color: "white"
      },
      "& .MuiTypography-h6": {
        lineHeight: "2.4rem",
        fontSize: "18px"
      }
    },
    required: {
      color: "#E41B17",
      "& :after": {
        content: "*"
      }
    },
    searchBox: {
      "& .MuiFormControl-root": {
        height: "36px"
      },
      margin: "2rem 1rem 1rem 1rem"
    },
    wrapper: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      marginTop: "1.6rem",
      marginBottom: "1.6rem",
      width: "100%"
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    container: {},
    leftSide: {
      width: "100%",
      margin: 0,
      borderRight: `1px solid ${theme.palette.grey[300]}`
    },
    rightSide: {
      width: "100%",
      margin: 0
    },
    flex: {
      display: "flex"
    },
    radioGroup: {
      flexDirection: "row"
    }
  }),
  { name: "ExcelUploadFilter" }
);

export default useStyles;
